<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-prompt :title="$t('NewCourse')" :accept-text="$t('Save')" :cancel-text="$t('Cancel')" @cancel="clearCourseModal"
      @accept="SaveCourse" @close="clearCourseModal" :is-valid="validateCourseForm" :active.sync="activePrompt">
      <VuePerfectScrollbar class="scroll-area p-4" style="min-height:400px" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent style="max-height:75vh">
          <label for="Course" class="vs-input--label">{{ $t('Course') }}</label>
          <!-- <v-select label="Name" class="w-full" v-model="course.Course" :options="courses" :reduce="Course => Course"
            append-to-body /> -->
          <v-select label="Name" class="w-full" v-model="course.Course" :options="courses" :reduce="Course => Course" />
          <vs-checkbox v-model="course.IsInstructor" class="mt-5">{{ $t('IsInstuctor') }}</vs-checkbox>
          <vs-checkbox v-model="course.IsExaminer" class="mt-5">{{ $t('IsExaminer') }} </vs-checkbox>
          <vs-checkbox v-model="course.IsPracticalAssessor" class="mt-5">{{ $t('IsPracticalAssessor') }}</vs-checkbox>
          <!-- <vs-select class="mt-5 w-full" label="Course" v-model="course.Course" >
                        <vs-select-item :key="index" :value="item" :text="item.Name" v-for="(item,index) in courses" />
                      </vs-select> -->
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <div>
      <div class="vx-row">

        <div class="vx-col lg:w-4/4 w-full">
          <vx-card title="Course can deliver" class="mb-base">
            <vs-button type="border" class="mb-4 mt-4" icon-pack="feather" icon="icon-plus"
              @click="activePrompt = true">{{ $t('AddCourse') }} </vs-button>

            <vs-table ref="table" pagination :max-items="5" :data="getListOfInstructorCourse">
              <template slot="thead">
                <vs-th>{{ $t('Course') }} </vs-th>
                <vs-th>{{ $t('Instructor') }} </vs-th>
                <vs-th>{{ $t('Examiner') }} </vs-th>
                <vs-th>{{ $t('PracticalAssessor') }} </vs-th>
                <vs-th>{{ $t('Action') }}</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.IsInstructor ? 'Yes' : '' }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.IsExaminer ? 'Yes' : '' }}</p>
                    </vs-td>
                    <vs-td>
                      <p class="product-name font-medium truncate">{{ tr.IsPracticalAssessor ? 'Yes' : '' }}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click.stop="editCourse(tr)" />
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"
                        @click="openConfirm(tr)" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleCourse from "@/store/course/moduleCourse.js";
export default {
  components: {

    vSelect,
    VuePerfectScrollbar
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activePrompt: false,
      instructorModel: this.data,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      course: {},
      dataForDeleted: {},
      edit: false,
      listOfInstructorCourse: [],
    }
  },
  computed: {
    validateCourseForm() {
      return this.course.Course != undefined
    },
    getListOfInstructorCourse() {
      return this.listOfInstructorCourse
    },
    courses() {
      debugger;
      return this.$store.state.courseList.courses;
    },
  },
  methods: {
    SaveCourse() {
      debugger;
      // const isExist = this.instructorModel.InstructorCourses.findIndex((p) => p.CourseID == this.course.Course.ID);
      // if(isExist>=0)
      // {
      //  // this.colorAlert = color
      //     this.$vs.dialog({
      //         color: "warning",
      //         title: `Dialog - warning`,
      //         text: 'This Course Already Exists'
      //     })
      //     this.course={};
      //     return;
      // }
      if (this.edit) {
        this.deleteCourse(this.dataForDeleted);
        this.edit = false;
      }
      this.course.CourseID = this.course.Course.ID;

      this.listOfInstructorCourse.unshift(this.course);
      this.instructorModel.InstructorCourses = this.listOfInstructorCourse;

      this.clearCourseModal();
    },

    acceptAlert() {
      this.deleteCourse(this.rowDataForDelete);
      this.$vs.notify({
        color: "danger",
        title: this.$t("Deletedrecord"),
        text: this.$t("Theselectedrecordwassuccessfullydeleted")
      });
    },
    deleteCourse(data) {
      debugger;
      if (data.ID > 0) {
        this.$store.dispatch("instructorList/removeCourse", data.ID);
      }
      const ItemIndex = this.instructorModel.InstructorCourses.findIndex((p) => p.CourseID == data.CourseID)
      // if(ItemIndex!=-1)
      this.instructorModel.InstructorCourses.splice(ItemIndex, 1)

    },
    editCourse(data) {
      this.edit = true;
      this.course = JSON.parse(JSON.stringify(data));
      this.dataForDeleted = this.course;
      this.activePrompt = true;

    },
    clearCourseModal() {
      this.course = {}
    },

    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("Confirm"),
        text: this.$t("Areyousureyouwantdeletethisrecord") + "?",
        accept: this.acceptAlert
      });
    },
  },
  created() {
    debugger;
    if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
    //mkl
    this.$store.dispatch("courseList/fetchDataListItems");
    if (this.instructorModel.InstructorCourses.length > 0) {
      this.listOfInstructorCourse = this.instructorModel.InstructorCourses;
    }
  }
}
</script>
